import { NoParamEndpointConstructor, SingleParamEndpointConstructor } from 'interfaces/api.interfaces'

const baseUrl = '/data-source-template-fields'

interface Endpoints {
  getAll: NoParamEndpointConstructor
  getSingle: SingleParamEndpointConstructor
  create: NoParamEndpointConstructor
  update: SingleParamEndpointConstructor
  remove: SingleParamEndpointConstructor
}

export const fieldsEndpoints: Endpoints = {
  getAll: () => `${baseUrl}`,
  getSingle: (id) => `${baseUrl}/${id}`,
  create: () => `${baseUrl}`,
  update: (id) => `${baseUrl}/${id}`,
  remove: (id) => `${baseUrl}/${id}`,
}
